import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmericanExpress = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15527_692)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M21.9976 0.336914H2.00807C1.17851 0.336914 0.503418 1.04803 0.503418 1.93078V14.0748C0.503418 14.9515 1.17851 15.6687 2.00807 15.6687H21.9976C22.8271 15.6687 23.5022 14.9576 23.5022 14.0748V1.92465C23.4965 1.04803 22.8271 0.336914 21.9976 0.336914Z",
			fill: "#2478BB"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.77145 5.5166L2.64893 10.4944H5.19481L5.50947 9.70357H6.23033L6.54499 10.4944H9.34261V9.88748L9.59434 10.4944H11.0418L11.2935 9.87522V10.4944H17.1176L17.827 9.72196L18.4906 10.4944L21.4771 10.5005L19.3431 8.01775L21.4713 5.5166H18.5307L17.8384 6.27675L17.1977 5.5166H10.8644L10.3209 6.79783L9.76597 5.5166H7.23152V6.10511L6.94547 5.5166H4.77145ZM5.26347 6.22771H6.50495L7.91234 9.60549V6.22771H9.26824L10.3552 8.64917L11.3564 6.22771H12.7066V9.80166H11.8828L11.8771 7.00013L10.6756 9.80166H9.9376L8.73045 7.00013V9.80166H7.03701L6.71663 8.99859H5.0003L4.67992 9.80166H3.77598L5.26347 6.22771ZM13.4675 6.22771H16.8086L17.8327 7.39859L18.8911 6.22771H19.9152L18.3591 8.02388L19.9152 9.79553H18.8454L17.8213 8.61239L16.7629 9.79553H13.4732V6.22771H13.4675ZM5.8699 6.82848L5.29779 8.25683H6.43629L5.8699 6.82848ZM14.2914 6.96334V7.61315H16.1164V8.33652H14.2914V9.04764H16.3395L17.2892 7.99936L16.3796 6.95721L14.2914 6.96334Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15527_692",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgAmericanExpress;
